/* @flow strict */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  .use(initReactI18next)
  .init({ // for all options read: https://www.i18next.com/overview/configuration-options
    lng: 'en',
    backend: {
      crossDomain: true,
      loadPath: '{{lng}}/{{ns}}.json',
      allowMultiLoading: false
    },
    fallbackLng: 'en',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },

    react: {
      wait: true,
      useSuspense: false,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
    }
  });


export default i18n;
